import { Box, Step, StepLabel, Stepper, styled } from '@mui/material';
import { PartnerTransferSection } from 'further-types/lp/partner-transfer';
import React from 'react';

const StepperContainer = styled(Box)({
  width: '800px',
});

const sectionLabels: Record<PartnerTransferSection, string> = {
  [PartnerTransferSection.PartnerTransfer]: 'Add partner transfer',
  [PartnerTransferSection.Investments]: 'Investments',
  [PartnerTransferSection.IncomeAndExpenses]: 'Income & Expenses',
  [PartnerTransferSection.Realisations]: 'Realisations',
  [PartnerTransferSection.Fees]: 'Fees',
  [PartnerTransferSection.CapitalActions]: 'Capital actions',
  [PartnerTransferSection.Summary]: 'Review',
};

const PartnerTransferStepper: React.FC<{
  sections: Array<PartnerTransferSection>;
  activeSection: PartnerTransferSection;
}> = ({ sections, activeSection }) => {
  const activeIndex = sections.indexOf(activeSection);
  return (
    <StepperContainer>
      <Stepper activeStep={activeIndex}>
        {sections.map((section) => (
          <Step key={section}>
            <StepLabel>
              {section === activeSection ? sectionLabels[section] : ''}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </StepperContainer>
  );
};

export default PartnerTransferStepper;
